export default __webpack_public_path__ + "static/media/Bengali_bf_2.8a0dda15.mp3";